const KONFOR_MOBILE_GRID_KEY = 'konfor-collection-mobile-grid';

function konforGetMobileGridCols() {
  try {
    return localStorage.getItem(KONFOR_MOBILE_GRID_KEY) === '1' ? '1' : '2';
  } catch (e) {
    return '2';
  }
}

function konforApplyMobileGrid(cols) {
  const nextCols = cols || konforGetMobileGridCols();
  const grid = document.getElementById('product-grid');
  if (grid) {
    grid.classList.remove('collection-grid--mobile-1', 'collection-grid--mobile-2');
    grid.classList.add('collection-grid--mobile-' + nextCols);
  }

  document.querySelectorAll('collection-grid-toggle [data-grid-cols]').forEach((btn) => {
    const on = btn.getAttribute('data-grid-cols') === nextCols;
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}

window.konforApplyMobileGrid = konforApplyMobileGrid;

if (!customElements.get('collection-grid-toggle')) {
  customElements.define(
    'collection-grid-toggle',
    class CollectionGridToggle extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.addEventListener('click', (event) => {
          const btn = event.target.closest('[data-grid-cols]');
          if (!btn) return;
          const cols = btn.getAttribute('data-grid-cols');
          try {
            localStorage.setItem(KONFOR_MOBILE_GRID_KEY, cols);
          } catch (e) {
            /* private mode */
          }
          konforApplyMobileGrid(cols);
        });
        konforApplyMobileGrid();
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => konforApplyMobileGrid());
